<template>
<sui-form>
    <sui-form-field class="required" v-bind:class="fieldClass('name')">
      <label>Name</label>
      <input placeholder="Name" v-validate="'required'" name="name" type="text"
        v-model="group.Name">
      <span>{{ errors.first('name') }}</span>
    </sui-form-field>
    <!-- <sui-form-field>
      <label>Start date</label>
      <input placeholder="Start date" name="start" type="date"
        v-model="group.Start">
      <span>{{ errors.first('start') }}</span>
    </sui-form-field>
    <sui-form-field>
      <label>End date</label>
      <input placeholder="End date" name="end" type="date"
        v-model="group.End">
      <span>{{ errors.first('end') }}</span>
    </sui-form-field> -->
    <div v-if="error" class="ui negative message">
      <p>{{ error }}</p>
    </div>
    <sui-button type="button" positive icon="plus" v-on:click="submit">
      {{ create ? 'Add class' : 'Update class' }}
    </sui-button>
  </sui-form>
</template>

<script>
export default {
  name: 'ClassForm',
  props: ['group', 'create', 'error'],
  methods: {
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/classes/ClassForm.vue